const headerFunctions = () => {
    ScrollTrigger.matchMedia({
        // Larger and Taller Screen
        "(min-width: 992px)": function() {
            // Change header items colour to dark when over a light background
            gsap.utils.toArray('.ci-block--cream').forEach((el, i) => {
                ScrollTrigger.create({
                    scroller: '.content-wrapper',
                    trigger: el,
                    start: () => {
                        const header = document.querySelector('.c-header');
                        const headerHeight = header.clientHeight;
                        
                        return 'top top-=-' + (headerHeight / 2);
                    },
                    end: () => {
                        const header = document.querySelector('.c-header');
                        const headerHeight = header.clientHeight;
                        
                        return 'bottom top-=-' + (headerHeight / 2);
                    },
                    toggleClass: {
                        targets: '.c-header',
                        className: 'c-header--dark'
                    }
                });
            });
        },
        // Smaller Screens
        "(max-width: 991px)": function() {
            ScrollTrigger.create({
                trigger: "html",
                start: () => {
                    const header = document.querySelector('.c-header');
                    const headerHeight = header.clientHeight;
                    
                    return 'top top-=' + (headerHeight / 2);
                },
                end: "bottom bottom",
                onToggle: (self) => {
                    if ( self.isActive ) {
                        $('.c-header').addClass('c-header--sticky');
                    } else {
                        $('.c-header').removeClass('c-header--sticky');
                    }
                }
            });
        }
    });
};